import { Button, Card, Checkbox, Modal, Typography } from '@mui/material';
import { FaFileExcel } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import toast, { LoaderIcon } from 'react-hot-toast';
import axios from 'axios';
import FileInputDropZone from '../../../ui/FileInput/FileInputDropZone';
import { useEffect, useRef, useState } from 'react';
import GlobalSpinner from '../../../Components2/common/GlobalSpinner';
import LoadedDataFormExcel from './LoadedDataFormExcel';
import FiltersArtes from '../FiltersArtes';
import { Buscador } from '../../Pedido/Buscador';
import { handleChangeInputSearch, handleClearInput, handleKeyDown } from '../../../helpers/buscadorHelper';
import useGetGenerateExcelNumberPreview from './useGetGenerateExcelNumberPreview';
import FilterMenuExcel from './FilterMenuExcel';
import BreadcrumbCategories from '../../Categories/BreadcrumbCategories';
import { useAuth0 } from '@auth0/auth0-react';
const ArticlesExcelModal = () => {
  const { getAccessTokenSilently } = useAuth0();
  const fileInputRef = useRef(null);
  const isMountedRef = useRef(true);
  const [fileName, setFileName] = useState('');
  const [dataExcel, setDataExcel] = useState(null);
  const [isReadingFile, setIsReadingFile] = useState(false);
  const [isGeneratingFile, setIsGeneratingFile] = useState(false);

  const [search, setSearch] = useState(null);
  const [centerTypeSelected, setCenterTypeSelected] = useState('all');
  const [statusSelected, setStatusSelected] = useState('all');
  const [centerSelected, setCenterSelected] = useState(null);
  const [superIdCategory, setSuperIdCategory] = useState(null);
  const [categorySelected, setCategorySelected] = useState([]);
  const [issuesFilter, setIssuesFilter] = useState('all');

  const [exportOptions, setExportOptions] = useState({
    articles: true,
    formats: true,
    providers: true,
  });

  const { data, isLoading, isFetching } = useGetGenerateExcelNumberPreview({
    centerTypeSelected,
    statusSelected,
    search,
    centerSelected,
    issuesFilter,
    superIdCategory: superIdCategory?._id,
  });

  const handleResetCategories = () => {
    setCategorySelected([]);
    setSuperIdCategory(null);
  };

  const handleMoveBackCategory = (el) => {
    const index = categorySelected.findIndex((c) => c._id === el._id);
    const newCategorySelected = categorySelected.slice(0, index + 1);
    setCategorySelected(newCategorySelected);
    setSuperIdCategory({ _id: el._id, parentCategory: el.parentCategory });
  };

  const navigate = useNavigate();

  const handleCloseModal = () => {
    navigate(`../`);
  };

  const handleImportExcel = async (file) => {
    setIsReadingFile(true);

    toast.loading('Leyendo Excel...', { id: 'reading-articles-excel' });

    try {
      const formData = new FormData();
      formData.append('file', file);
      const token = await getAccessTokenSilently();

      const response = await axios.post('/api/v1/excel/articles/read', formData, {
        headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${token}` },
      });
      const data = response.data?.data;

      if (!isMountedRef.current) return;

      setDataExcel(data);
      setIsReadingFile(false);

      toast.success('Excel leído correctamente', { id: 'reading-articles-excel' });
    } catch (err) {
      if (!isMountedRef.current) return;

      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }

      console.error('Error al leer el Excel', err);

      setIsReadingFile(false);
      toast.error(err.message || 'Error al leer el Excel', { id: 'reading-articles-excel' });
    }
  };

  const handleClickExport = async (type) => {
    const toastId = 'exporting-articles-excel';
    toast.loading('Exportando...', { id: toastId, duration: Infinity });
    setIsGeneratingFile(true);

    try {
      const token = await getAccessTokenSilently();
      const response = await axios.get('/api/v1/excel/articles', {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          centerTypeSelected,
          statusSelected,
          search,
          centerSelected,
          idCategory: superIdCategory?._id ?? null,
          type,
          exportOptions,
          issuesFilter,
        },
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(response.data);
      const a = document.createElement('a');
      a.href = url;
      const now = new Date();
      const dateStr = `${String(now.getDate()).padStart(2, '0')}_${String(now.getMonth() + 1).padStart(
        2,
        '0',
      )}_${now.getFullYear()}`;
      a.download = type === 'template' ? 'plantilla_catalago.xlsx' : `catalago_exportado_${dateStr}.xlsx`;

      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);

      toast.success('Exportado', { id: toastId, duration: 2000 });
    } catch (err) {
      console.error('Error al exportar', err);
      toast.error('Error al exportar', { id: toastId, duration: 2000 });
    } finally {
      setIsGeneratingFile(false);
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    toast.dismiss('reading-articles-excel');
    return () => {
      isMountedRef.current = false;
      toast.dismiss('reading-articles-excel');
    };
  }, []);

  return (
    <Modal onClose={handleCloseModal} open>
      <div className="articles-excel-container-modal">
        <Typography
          variant="h4"
          component="h2"
          align="center"
          sx={{
            fontWeight: 'bold',
            marginBottom: '1.5rem',
            backgroundColor: '#3C4145',
            color: 'white',
            paddingX: '5rem',
          }}
        >
          IMPORTAR/ EXPORTAR EXCEL
        </Typography>
        {!isReadingFile && !isGeneratingFile ? (
          <>
            {dataExcel === null ? (
              <div className="articles-excel-content">
                <div className="generate-excel-container">
                  <div className="articles-excel-content categories">
                    <FilterMenuExcel
                      search={search}
                      statusSelected={statusSelected}
                      centerTypeSelected={centerTypeSelected}
                      centerSelected={centerSelected}
                      superIdCategory={superIdCategory}
                      setSuperIdCategory={setSuperIdCategory}
                      categorySelected={categorySelected}
                      setCategorySelected={setCategorySelected}
                    />
                  </div>
                  <div className="articles-excel-content main">
                    <BreadcrumbCategories
                      categorySelected={categorySelected}
                      handleReset={handleResetCategories}
                      handleMoveBack={handleMoveBackCategory}
                    />
                    <div className="articles-excel-content-search">
                      <Buscador
                        label="Buscar por nombre, por código de ariba, por palabra clave..."
                        value={search}
                        width="85"
                        onChange={(e) => handleChangeInputSearch(e, setSearch)}
                        onKeyDown={(e) => handleKeyDown(e, setSearch)}
                        onClear={() => handleClearInput(setSearch)}
                      />
                    </div>
                    <FiltersArtes
                      valueCenter={centerSelected}
                      setValueCenter={setCenterSelected}
                      valueCenterType={centerTypeSelected}
                      setValueCenterType={setCenterTypeSelected}
                      valueStatus={statusSelected}
                      setValueStatus={setStatusSelected}
                      issuesFilter={issuesFilter}
                      setIssuesFilter={setIssuesFilter}
                      withValidation
                    />

                    <div className="articles-excel-cards-container">
                      <Card className="articles-excel-card">
                        <Checkbox
                          className="card-checkbox"
                          disabled={data?.data?.totalArtesFinales === 0 || isLoading || isFetching}
                          checked={exportOptions.articles}
                          onChange={(e) =>
                            setExportOptions({
                              ...exportOptions,
                              articles: e.target.checked,
                            })
                          }
                        />
                        <h1 className={data?.data?.totalArtesFinales !== 0 ? 'created' : ''}>
                          {!isLoading && !isFetching ? (
                            data?.data?.totalArtesFinales
                          ) : (
                            <LoaderIcon
                              style={{
                                height: '1.2rem',
                                width: '1.2rem',
                              }}
                            />
                          )}
                        </h1>
                        <span>Articulos</span>
                      </Card>
                      <Card className="articles-excel-card">
                        <Checkbox
                          className="card-checkbox"
                          disabled={data?.data?.totalFormats === 0 || isLoading || isFetching}
                          checked={exportOptions.formats}
                          onChange={(e) =>
                            setExportOptions({
                              ...exportOptions,
                              formats: e.target.checked,
                            })
                          }
                        />

                        <h1 className={data?.data?.totalFormats !== 0 ? 'created' : ''}>
                          {!isLoading && !isFetching ? (
                            data?.data?.totalFormats
                          ) : (
                            <LoaderIcon
                              style={{
                                height: '1.2rem',
                                width: '1.2rem',
                              }}
                            />
                          )}
                        </h1>
                        <span>Formatos</span>
                      </Card>
                      <Card className="articles-excel-card">
                        <Checkbox
                          disabled={data?.data?.totalProviderFormats === 0 || isLoading || isFetching}
                          className="card-checkbox"
                          checked={exportOptions.providers}
                          onChange={(e) =>
                            setExportOptions({
                              ...exportOptions,
                              providers: e.target.checked,
                            })
                          }
                        />

                        <h1 className={data?.data?.totalProviderFormats !== 0 ? 'created' : ''}>
                          {!isLoading && !isFetching ? (
                            data?.data?.totalProviderFormats
                          ) : (
                            <LoaderIcon
                              style={{
                                height: '1.2rem',
                                width: '1.2rem',
                              }}
                            />
                          )}
                        </h1>
                        <span>Proveedores</span>
                      </Card>
                    </div>
                    <Button
                      size="small"
                      variant="contained"
                      color="success"
                      startIcon={<FaFileExcel />}
                      onClick={handleClickExport}
                      disabled={
                        isLoading ||
                        isFetching ||
                        data?.data?.totalArtesFinales === 0 ||
                        (exportOptions.articles === false &&
                          exportOptions.formats === false &&
                          exportOptions.providers === false)
                      }
                    >
                      EXPORTAR CATALOGO
                    </Button>
                  </div>
                </div>

                <hr className="separator" />

                <FileInputDropZone
                  onFileSelect={handleImportExcel}
                  label="Arrastra y suelta la plantilla de Excel aquí"
                  forwardedRef={fileInputRef}
                  onSetFileName={(name) => setFileName(name)}
                />
                <Button
                  size="small"
                  variant="contained"
                  color="success"
                  startIcon={<FaFileExcel />}
                  onClick={() => handleClickExport('template')}
                >
                  DESCARGAR PLANTILLA CATALOGO PARA IMPORTAR
                </Button>
              </div>
            ) : (
              <LoadedDataFormExcel
                dataExcel={dataExcel}
                setDataExcel={setDataExcel}
                fileName={fileName}
                setFileName={setFileName}
              />
            )}
          </>
        ) : (
          <div className="loader-container-excel">
            {isReadingFile && <div>Leyendo archivo excel {fileName}, por favor espere...</div>}
            {isGeneratingFile && <div>Generando archivo excel, por favor espere...</div>}
            <GlobalSpinner />
            <div>Este proceso podria tardar varios varios minutos en funcion del tamaño del archivo.</div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ArticlesExcelModal;
